import React from 'react';
import './_configurationBot.scss';
import { injectIntl } from 'react-intl';

import IdentityIcon from './IdentityIcon';
import { IDENTITY_ICON_TYPES } from './constants';
import CapIcon from '../../CapIcon';
import { Spin } from 'antd';

const GeneratingResponse = ({
  intl: { formatMessage },
  textGeneratingResponse,
  progressStatusData,
}) => {
  const [dots, setDots] = React.useState('');

  React.useEffect(
    () => {
      const updateDots = () => {
        if (dots.length === 5) {
          setDots('');
        } else {
          setDots(dots + '.');
        }
      };
      const timeout = setTimeout(updateDots, 500);
      return () => {
        clearTimeout(timeout);
      }
    },
    [dots],
  );

  return (
    <div className="generating-container">
      <IdentityIcon
        iconType={IDENTITY_ICON_TYPES.COPILOT}
        style={{ justifySelf: 'center' }}
      />
      <div>
        {textGeneratingResponse}
        {dots}
      </div>
      {progressStatusData?.length > 0 &&
        progressStatusData.map((status, index) => {
          let icon = (
            <div
              style={{
                position: 'relative',
                justifySelf: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
              }}
              data-testid="loading-spinner"
            >
              <Spin
                size="small"
                style={{ lineHeight: 0, position: 'relative' }}
              />
            </div>
          );
          if (index < progressStatusData.length - 1 || status?.dontLoad) {
            icon = (
              <CapIcon
                size="s"
                className="completed-icon"
                type="check-filled"
                style={{ justifySelf: 'center' }}
                data-testid="completed-icon"
              />
            );
          }
          return (
            <React.Fragment key={index}>
              {icon}
              <div>{status?.message}</div>
            </React.Fragment>
          );
        })}
    </div>
  );
};

GeneratingResponse.defaultProps = {};
export default injectIntl(GeneratingResponse);
